import { Comment, isRootComment } from '@basehub/data/replicache/index'
import { Link1Icon, Pencil1Icon, TrashIcon } from '@radix-ui/react-icons'
import { Replicache } from 'replicache'
import { PublicUser } from '~/app/api/users/public-user-schema'
import type { RepoSpaceMutators } from '@basehub/data/replicache/mutators/repo-space/mutators'

export type CommentAction = {
  label: string
  icon: React.ReactNode
  isDestructive: boolean
  action: () => void
}

export const getActionsForComment = ({
  onEdit,
  replicache,
  comment,
  user,
  copyLink,
}: {
  onEdit?: () => void
  replicache?: Replicache<RepoSpaceMutators> | undefined
  comment: Comment
  user: PublicUser | null
  copyLink: () => void
}): CommentAction[] | null => {
  if (!user) return null
  const actions = []
  actions.push({
    label: 'Copy link',
    icon: <Link1Icon className="size-3.5" />,
    isDestructive: false,
    action: copyLink,
  })
  if (user.id !== comment.authorId) return actions
  if (onEdit) {
    actions.push({
      label: 'Edit',
      icon: <Pencil1Icon className="size-3.5" />,
      isDestructive: false,
      action: onEdit,
    })
  }
  if (!isRootComment(comment)) {
    actions.push({
      label: 'Delete',
      icon: <TrashIcon className="size-3.5" />,
      isDestructive: true,
      action: () => {
        replicache?.mutate.deleteComment({ id: comment.id })
      },
    })
  }

  return actions
}
